// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"265":"0f472188","390":"c6918fb5","399":"ba231f6a","561":"669074e7","705":"652cb95c","896":"64a809a7"}[chunkId] + ".css";
};